
import isEqual from 'react-fast-compare';

export default (prevProps, newProps) => {
    return isEqual(prevProps, newProps);
};
